
import _keyBy from "lodash/keyBy"
import _propertyOf from "lodash/propertyOf"
import $ from "jquery"
import {
  onClickOutside,
} from "plugins/vanilla-clickout"
import "multiple-select"
import {EventEmitter} from "events"

import {
  captureMessage,
} from "app/error_reporting"


import I18n from "plugins/i18n-js"


interface Selector {
  scope:            string | Element | JQuery
  wrapper:          string | Element | JQuery
  main:             string | Element | JQuery
  data:             string | Element | JQuery
  input:            string | Element | JQuery
  checked:          string | Element | JQuery
  container:        string | Element | JQuery
  display_checked:  string | Element | JQuery
  checked_group:    string | Element | JQuery
  menu:             string | Element | JQuery
}
export interface InputSelector {
  scope?:            string | Element | JQuery
  wrapper?:          string | Element | JQuery
  main?:             string | Element | JQuery
  data?:             string | Element | JQuery
  input?:            string | Element | JQuery
  checked?:          string | Element | JQuery
  container?:        string | Element | JQuery
  display_checked?:  string | Element | JQuery
  checked_group?:    string | Element | JQuery
  menu?:             string | Element | JQuery
}

const default_selector = {
  scope:            ".cell--buildings--overseas-marketing--filter",
  wrapper:          ".cell--buildings--overseas-marketing--filter--form__countries_wrapper",
  main:             ".cell--buildings--overseas-marketing--filter--form__countries",
  data:             ".cell--buildings--overseas-marketing--filter__data-country-city",
  input:            ".ms-search input",
  checked:          "input[type='checkbox']:checked",
  container:        ".ms-drop",
  display_checked:  ".ms-drop .ms-selected input[type='checkbox']:checked",
  checked_group:    ".ms-drop li.group input[type='checkbox']:checked",
  menu:             ".ms-drop ul",
}

const min_string = (str = "") => str.toLowerCase().replace(/\s+/, "")
const is_substr = (str: string, substr: string) => str.indexOf(substr) >= 0
const getProperty = (obj: object, key_string: string) => {
  return key_string.split(".").reduce((scope, key) => _propertyOf(scope)(key), obj)
}


class CountriesSelector extends EventEmitter {
  protected selector: Selector

  protected $scope: JQuery
  protected $wrapper: JQuery
  protected $el: JQuery

  protected $data: JQuery
  protected height: number
  protected country_data: {
    [index: string]: {
      slug: string,
      name: string,
    }
  }

  protected $menu: JQuery
  protected $input: JQuery

  constructor(selector?: InputSelector){
    super()

    this.selector = Object.assign({}, default_selector, selector)

    this.$scope = $(this.selector.scope)

    this.$wrapper = (typeof this.selector.wrapper === "string") ?
      this.$scope.find(this.selector.wrapper) :
      this.$scope.find(this.selector.wrapper)

    this.$el = (typeof this.selector.main === "string") ?
      this.$wrapper.find(this.selector.main) :
      this.$wrapper.find(this.selector.main)

    this.$data = $(this.selector.data)

    this.height = Math.round(($(window).height() || 0) * 0.6)
    this.country_data = {}

    this.$menu = this.$scope.find(this.selector.menu)
    this.$input = this.$scope.find(this.selector.input)

    if (this.$el.length !== 1){
      captureMessage(
        `this.$el initialize with 0 / >1 element is unexpected: ${this.$el.length}`,
        {
          source_file_path: "app/assets/javascripts/concepts/buildings/overseas_marketing/filter_bar/desktop/cities_selector/index.ts",
          element_paths:    this.$el.toArray().map((suspect_el) => {
            const rightArrowParents = [] as string[]
            $(suspect_el).parents().addBack().not("html").each((_idx, el) => {
              let entry = el.tagName.toLowerCase()
              if (el.id.length > 0) {
                entry += "#" + el.id.trim()
              }
              if (el.className) {
                entry += "." + el.className.trim().replace(/ /g, ".")
              }
              rightArrowParents.push(entry)
            })
            return rightArrowParents.join(" ")
          }).join("\n"),
        }
      )
      throw new Error("cities_selector initialize with 0 / >1 element")
    }

    this.created()
    this.bind_action()

    return this
  }

  public isDefault(){
    return this.$wrapper.find("input[type=\"checkbox\"]:checked").length === 0
  }
  public reset(){
    this.$el.find("option").prop("selected", false)
    this.$el.multipleSelect("uncheckAll")
  }
  public selected_items(){
    return this.$el.val()
  }

  protected created(){
    try{
      this.country_data = _keyBy(JSON.parse(this.$data.text()).countries, "slug")
    }
    catch (e){
      this.country_data = {}
    }

    this.$el.multipleSelect(this.multipleSelectOptions())

    this.$menu.height(this.height)

    this.close()
    return this
  }

  protected bind_action(){
    this.$el.on("change", () => {
      this.onChange()
    })
    this.$input.on("keydown", (e) => {
      this.onKeyDown(e)
    })
    onClickOutside(this.$scope[0] as HTMLElement, () => {
      this.onClickout()
    })
  }
  protected filterFunction(item: {value: string}, text: string){
    const key = item.value
    return [
      getProperty(this.country_data, `${key}.name_in_current_locale`),
    ].some((name) => {
      return is_substr(min_string(name), min_string(text))
    })
  }
  protected groupFilterFunction(item: {parentElement: {textContent: string}}, text: string){
    return is_substr(min_string(item.parentElement.textContent), text)
  }
  protected close(){
    this.$el.multipleSelect("close")
  }
  protected onClick(){
    this.emit("click")
  }
  protected onChange(){
    this.emit("val_change")
  }
  protected onClear(){
    this.$el.multipleSelect("filter")
  }
  protected onClickout(){
    this.close()
  }
  protected onKeyDown(e){
    if (e.keyIdentifier === "Enter" || e.keyCode === 13){
      e.preventDefault()
    }
  }

  protected multipleSelectOptions(): object {
    const that = this

    return {
      multiple:             true,
      width:                "100%",
      filter:               true,
      clearAll:             I18n.t("simple_form.placeholders.listing_search.clear_all"),
      clearAllPosition:     "after_selected_area",
      pickoutSelected:      true,
      selectAll:            false,
      multipleSelectFilteredOnly: false,
      multipleWidth:        200,
      maxHeight:            "auto",
      minimumCountSelected: 0,
      allSelected:          I18n.t("concepts.buildings.overseas_marketing.filter_bar.placeholder.countries.all_items_selected"),
      countSelected:        I18n.t("concepts.buildings.overseas_marketing.filter_bar.placeholder.countries.n_items_selected"),
      placeholder:          I18n.t("concepts.buildings.overseas_marketing.filter_bar.criteria.country"),
      input_placeholder:    I18n.t("concepts.buildings.overseas_marketing.filter_bar.buttons.search_countries"),
      noMatchesFound:       I18n.t("concepts.buildings.overseas_marketing.filter_bar.placeholder.countries.none_found"),
      filterFunction: (item, text) => {
        return this.filterFunction(item, text)
      },
      groupFilterFunction(item, text){
        return that.groupFilterFunction(item, text)
      },
      onClick(){
        that.onClick()
      },
      onOptgroupClick(){
        that.onClick()
      },
      hasPNGArrow: false,
    }
  }
}

const Factory = {
  create(selector?: InputSelector){
    return new CountriesSelector(Object.assign({}, default_selector, selector))
  },
}

export {
  Factory,
  CountriesSelector,
}
